var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "header",
      class: [_vm.type, _vm.subtitle.length > 0 ? "" : "single"]
    },
    [
      _c("div", { staticClass: "l" }),
      _c("div", { staticClass: "m" }, [
        _vm._v(_vm._s(_vm.name)),
        _vm.subtitle.length > 0 ? _c("br") : _vm._e(),
        _vm._v(_vm._s(_vm.subtitle))
      ]),
      _c("div", { staticClass: "r" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
/* hot reload */
if (module.hot) {
  var api = require("/Users/simone/Dev/node/poekit-rack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (module.hot.data) {
      require("/Users/simone/Dev/node/poekit-rack/node_modules/vue-hot-reload-api/dist/index.js").rerender('568b55c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    }
  }
}export { render, staticRenderFns }